import { NotificationDetailDto } from "@dto/notification-detail/notification-detail.dto";
import { createReducer, on } from "@ngrx/store";
import {
  initNotificationDetail,
  initNotificationDetailFailure,
  initNotificationDetailSuccess,
} from "@store/notification-detail/notification-detail.action";
import { NullableType } from "@type/nullable.type";

export interface NotificationDetailState {
  notificationDetail: {
    sourceId: NullableType<string>,
    data: NullableType<NotificationDetailDto>,
    isLoading: boolean,
    error: NullableType<string>
  };
}

export const initialState: NotificationDetailState = {
  notificationDetail: { sourceId: null, data: null, isLoading: false, error: null }
}

export const notificationDetailReducer = createReducer(
  initialState,
  on(initNotificationDetail, (state, { sourceId }) => (
    {
      ...initialState,
      notificationDetail: { ...initialState.notificationDetail, sourceId, isLoading: true }
    })
  ),

  on(initNotificationDetailSuccess, (state, { data }) => (
    {
      ...state,
      notificationDetail: { ...state.notificationDetail, data, isLoading: false }
    })
  ),

  on(initNotificationDetailFailure, (state, { error }) => (
    {
      ...state,
      notificationDetail: { ...state.notificationDetail, error, isLoading: false }
    })
  )
)
